import { h, Host, } from "@stencil/core";
//import { requiredLabel, formMessage } from "../../common.js";
import state from "../store.js";
export class FormSelectV2 {
    constructor() {
        this.label = undefined;
        this.labelPosition = "above";
        this.required = false;
        this.size = undefined;
        this.value = undefined;
        this.width = "100%";
        this.minWidth = undefined;
        this.maxWidth = undefined;
        this.disabled = false;
        this.warning = false;
        this.error = false;
        this.visible = false;
        this.myObserver = null;
    }
    slottedContent;
    el;
    selectedValueRef;
    /**
     * Returns the value of the selected option
     */
    change;
    detectClickOutsideSelect = this.detectClickOutsideSelectFunc.bind(this);
    detectMouseScroll = this.detectMouseScrollFunc.bind(this);
    optionIsSelectedHandler(event) {
        this.value = event.detail;
    }
    handlerOnKeyDown(event) {
        if (event.keyCode == 9) {
            //tab key was pressed
            if (event.shiftKey) {
                //shift key was also pressed
                this.el.previousSibling.previousSibling.focus();
            }
        }
    }
    selectedValue() {
        let selectedOption = undefined;
        const activeOption = this.el.querySelector("gxg-option-v2[selected]");
        if (activeOption) {
            selectedOption = activeOption;
        }
        else {
            //show the first
            selectedOption = this.el.querySelector("gxg-option-v2");
        }
        return selectedOption.innerText;
    }
    detectClickOutsideSelectFunc(event) {
        const comboMainContainer = this.el.shadowRoot.querySelector(".main-container");
        const x = event.x;
        const y = event.y;
        //Contextual menu coordinates
        const comboMainContainerArea = comboMainContainer.getBoundingClientRect();
        if ((x > comboMainContainerArea.left &&
            x < comboMainContainerArea.right &&
            y > comboMainContainerArea.top &&
            y < comboMainContainerArea.bottom) ||
            (event.screenX === 0 &&
                event.screenY === 0 &&
                event.clientX === 0 &&
                event.clientY === 0)) {
            //Click happened inside the combo
        }
        else {
            this.visible = false;
            //Click happened outside the combo
        }
    }
    componentDidLoad() {
        this.resizeObserver();
    }
    disconnectedCallback() {
        this.myObserver.unobserve(document.body);
        document.removeEventListener("click", this.detectClickOutsideSelect, true);
        document.removeEventListener("scroll", this.detectMouseScroll, true);
    }
    detectMouseScrollFunc() {
        this.visible = false;
    }
    resizeObserver() {
        this.myObserver = new ResizeObserver((entries) => {
            entries.forEach(() => {
                this.repositionItemsContainer();
            });
        });
        this.myObserver.observe(document.body);
        this.myObserver.observe(this.el);
    }
    repositionItemsContainer() {
        //redefine .main-container width
        const gxgComboWidth = this.el.clientWidth;
        this.selectedValueRef.style.width = gxgComboWidth + "px";
        //redefine .items-container "top" value
        const gxgComboCoordinates = this.el.getBoundingClientRect();
        const gxgComboY = gxgComboCoordinates.y;
        const gxgComboHeight = gxgComboCoordinates.height;
        this.selectedValueRef.style.top = gxgComboY + gxgComboHeight + "px";
    }
    toggle() {
        this.visible = !this.visible;
    }
    render() {
        return (h(Host, { style: {
                minWidth: this.minWidth,
                maxWidth: this.maxWidth,
                "--size": this.size,
            }, class: {
                large: state.large,
            }, onKeyDown: this.handlerOnKeyDown.bind(this) }, this.label ? (h("label", { class: {
                label: true,
            } }, this.label)) : null, h("div", { class: { "form-wrapper": true } }, h("div", { class: "selected-value", onClick: this.toggle.bind(this), ref: (el) => (this.selectedValueRef = el) }, this.selectedValue()), this.visible ? (h("div", { class: "options" }, h("slot", null))) : null)));
    }
    static get is() { return "gxg-select-v2"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["select-v2.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["select-v2.css"]
        };
    }
    static get properties() {
        return {
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The select label"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "labelPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "LabelPosition",
                    "resolved": "\"above\" | \"start\"",
                    "references": {
                        "LabelPosition": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-select-v2/gxg-select-v2.tsx",
                            "id": "src/components/form-select-v2/gxg-select-v2.tsx::LabelPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label position"
                },
                "attribute": "label-position",
                "reflect": false,
                "defaultValue": "\"above\""
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes this input required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "size": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The maximum number of visible options"
                },
                "attribute": "size",
                "reflect": false
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This holds the value of the selected option"
                },
                "attribute": "value",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "width": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The select width"
                },
                "attribute": "width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "minWidth": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The select min. width"
                },
                "attribute": "min-width",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "maxWidth": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The select max. width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disables the component"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "warning": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute stylizes the component with warning attributes"
                },
                "attribute": "warning",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute stylizes the component with error attributes"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "visible": {},
            "myObserver": {}
        };
    }
    static get events() {
        return [{
                "method": "change",
                "name": "change",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Returns the value of the selected option"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "optionIsSelected",
                "method": "optionIsSelectedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=gxg-select-v2.js.map
